import { render, staticRenderFns } from "./QR.vue?vue&type=template&id=b348c3dc&scoped=true"
import script from "./QR.vue?vue&type=script&lang=js"
export * from "./QR.vue?vue&type=script&lang=js"
import style0 from "./QR.vue?vue&type=style&index=0&id=b348c3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b348c3dc",
  null
  
)

export default component.exports